/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import forEach from 'lodash/forEach';
import filter from 'lodash/filter';

import {
    Tabs,
    TabPanel,
    SecurityHelper,
    Box,
    StyledModal,
    ModalActions,
    ButtonGroup,
    Button,
    Alert,
} from 'sarsaparilla';
import { withCompatRouter, COMPAT_ROUTER_PROP_TYPES } from 'sarsaparilla/legacy';
import { gnoment } from 'shared-ui/gnoment';
import { RecaptchaCheckbox, withRecaptchaFallback } from 'shared-ui/recaptcha';
import AvailabilityMonths from 'ui-permit/shared-components/detailed-availability/AvailabilityMonthsNew';
import { SharedCaptchaModal } from 'shared-ui/components/RecaptchaModal/SharedCaptchaModal';
import { authModalActions } from 'shared-ui/auth';
import WeeklyMotorAvailability from '../components/WeeklyMotorAvailability';
import OvernightAvailabilityGrid from '../components/OvernightAvailabilityGrid';
import AvailabilityNavigator from '../components/AvailabilityNavigator';
import BookNowComponent from '../components/BookNowComponent';

import * as aActions from '../actions/availability';
import * as pActions from '../actions/permit';
import * as types from '../constants';
import { issuanceStatuses, formatErrorMessage } from '../utils/permitUtilsNew';
import {
    getGateA,
    RECAPTCHA_ACTION_CREATE_ISSUANCE,
    RECAPTCHA_FAILED_MESSAGE,
} from '../utils/recaptcha';

const propTypes = {
    router: COMPAT_ROUTER_PROP_TYPES,
    permitId: PropTypes.string,
    permitDate: PropTypes.string,
    activeTab: PropTypes.number,
    availabilities: PropTypes.object,
    divisions: PropTypes.object,
    questionnaire: PropTypes.object,
    selectedStartDate: PropTypes.string,
    selectedEndDate: PropTypes.string,
    selectedDivision: PropTypes.object,
    selectedStartDate2: PropTypes.string,
    selectedEndDate2: PropTypes.string,
    selectedDivision2: PropTypes.object,
    divisionSearchCriteria: PropTypes.object,
    dispatch: PropTypes.func,
    issuanceLoading: PropTypes.bool,
    isSmallerGrid: PropTypes.bool,
    numOfCols: PropTypes.number,
    daysToSkip: PropTypes.number,
    isFullView: PropTypes.bool,
    account: PropTypes.object,
    handleDateChange: PropTypes.func,
    existingIssuance: PropTypes.any,
    recaptcha: PropTypes.object,
};

const defaultProps = {};

export class AvailabilityCanadaMotorContainer extends React.Component {
    static displayName = 'AvailabilityCanadaMotorContainer';

    static propTypes = propTypes;

    static defaultProps = defaultProps;

    constructor(props) {
        super(props);
        this.state = {
            permitId: props.permitId,
            permitDate: props.permitDate,
            divisions: props.divisions,
            isMessageModalOpen: false,
            message: null,
            messageTitle: null,
            waitingForUserAccount: false,
            isChallengeModalOpen: false,
        };
        this.onNavigatorDateChanged = this.onNavigatorDateChanged.bind(this);
        this.onToCanadaSelectToggle = this.onToCanadaSelectToggle.bind(this);
        this.onFromCanadaSelectToggle = this.onFromCanadaSelectToggle.bind(this);
        this.onClearToCanadaDates = this.onClearToCanadaDates.bind(this);
        this.onClearFromCanadaDates = this.onClearFromCanadaDates.bind(this);
        this.onBook = this.onBook.bind(this);
        this.onCloseMessageModal = this.onCloseMessageModal.bind(this);
        this.handleSpendNightOnWayToCanadaChange =
            this.handleSpendNightOnWayToCanadaChange.bind(this);
        this.handleSpendNightOnWayFromCanadaChange =
            this.handleSpendNightOnWayFromCanadaChange.bind(this);
    }

    componentDidMount() {
        this.refreshAvailability();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            nextProps.permitDate !== this.state.permitDate ||
            JSON.stringify(nextProps.divisions) !==
                JSON.stringify(this.props.divisions) ||
            JSON.stringify(nextProps.divisionSearchCriteria) !==
                JSON.stringify(this.props.divisionSearchCriteria)
        ) {
            this.setState(
                {
                    permitId: nextProps.permitId,
                    permitDate: nextProps.permitDate,
                    divisions: nextProps.divisions,
                },
                () => {
                    this.refreshAvailability();
                }
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (
            SecurityHelper.isLoggedIn() &&
            this.state.waitingForUserAccount &&
            this.props.account &&
            prevProps.account !== this.props.account
        ) {
            this.setState({ waitingForUserAccount: false });
            this.onBook();
        }
    }

    handleSpendNightOnWayToCanadaChange(changeEvent) {
        this.props.dispatch(
            pActions.setQuestionnaireAnswers({
                motorSpendNightOnWayToCanada: changeEvent.target.value,
            })
        );
        this.props.dispatch(
            pActions.setDivisionSearchCriteria({
                searchText: this.props.divisionSearchCriteria.searchText,
                areas: this.props.divisionSearchCriteria.areas,
                motorSize: this.props.divisionSearchCriteria.motorSize,
                canadianAccess: changeEvent.target.value,
            })
        );
        this.props.dispatch(pActions.setSelectedStartDate(null));
        this.props.dispatch(pActions.setSelectedEndDate(null));
        this.props.dispatch(pActions.setSelectedDivision(null));
    }

    handleSpendNightOnWayFromCanadaChange(changeEvent) {
        this.props.dispatch(
            pActions.setQuestionnaireAnswers({
                motorSpendNightOnWayFromCanada: changeEvent.target.value,
            })
        );
        this.props.dispatch(
            pActions.setDivisionSearchCriteria({
                searchText: this.props.divisionSearchCriteria.searchText,
                areas: this.props.divisionSearchCriteria.areas,
                motorSize: this.props.divisionSearchCriteria.motorSize,
                canadianAccess: changeEvent.target.value,
            })
        );
        this.props.dispatch(pActions.setSelectedStartDate2(null));
        this.props.dispatch(pActions.setSelectedEndDate2(null));
        this.props.dispatch(pActions.setSelectedDivision2(null));
    }

    onToCanadaSelectToggle(division, startDate, endDate) {
        if (
            this.props.selectedStartDate === startDate &&
            this.props.selectedDivision &&
            this.props.selectedDivision.id === division.id
        ) {
            this.props.dispatch(pActions.setSelectedStartDate(null));
            this.props.dispatch(pActions.setSelectedEndDate(null));
        } else {
            this.props.dispatch(pActions.setSelectedStartDate(startDate));
            this.props.dispatch(pActions.setSelectedEndDate(endDate));
        }
        this.props.dispatch(pActions.setSelectedDivision(division));
    }

    onFromCanadaSelectToggle(division, startDate, endDate) {
        if (
            this.props.selectedStartDate2 === startDate &&
            this.props.selectedDivision2 &&
            this.props.selectedDivision2.id === division.id
        ) {
            this.props.dispatch(pActions.setSelectedStartDate2(null));
            this.props.dispatch(pActions.setSelectedEndDate2(null));
        } else {
            this.props.dispatch(pActions.setSelectedStartDate2(startDate));
            this.props.dispatch(pActions.setSelectedEndDate2(endDate));
        }
        this.props.dispatch(pActions.setSelectedDivision2(division));
    }

    onClearToCanadaDates() {
        this.props.dispatch(pActions.setSelectedStartDate(null));
        this.props.dispatch(pActions.setSelectedEndDate(null));
    }

    onClearFromCanadaDates() {
        this.props.dispatch(pActions.setSelectedStartDate2(null));
        this.props.dispatch(pActions.setSelectedEndDate2(null));
    }

    onCloseMessageModal() {
        this.setState({
            isMessageModalOpen: false,
            message: null,
            messageTitle: null,
        });
    }

    async onBook() {
        const loggedIn = SecurityHelper.isLoggedIn();
        if (!loggedIn) {
            this.setState({ waitingForUserAccount: true });
            this.props.dispatch(authModalActions.openLoginModal());
            return;
        }
        // A v2 challenge was previously required - show the checkbox modal before
        // resubmitting. Once open, fall through and submit the v2 token.
        if (
            this.props.recaptcha.isChallengeRequired &&
            !this.state.isChallengeModalOpen
        ) {
            this.setState({ isChallengeModalOpen: true });
            return;
        }
        const permitId = types.BOUNDARY_WATERS_PERMIT_ID;
        const items = [];
        if (this.props.selectedDivision && this.props.selectedStartDate) {
            let permitType = types.TYPE_OVERNIGHT_MOTOR;
            if (this.props.questionnaire.motorSpendNightOnWayToCanada === 'no') {
                permitType = types.TYPE_DAYUSE_MOTOR;
            }
            const item = {
                permit_id: permitId,
                permit_type: permitType,
                division_id: this.props.selectedDivision.id,
                user_id: SecurityHelper.getAccount().account_id,
                start_date: gnoment(this.props.selectedStartDate),
                status: issuanceStatuses.get(types.PERMIT_PRELIMINARY),
                equipments: [
                    {
                        type: types.EQUIP_TYPE_MOTORBOAT,
                        qty: 1,
                    },
                ],
            };
            items.push(item);
        }
        if (this.props.selectedDivision2 && this.props.selectedStartDate2) {
            let permitType = types.TYPE_OVERNIGHT_MOTOR;
            if (this.props.questionnaire.motorSpendNightOnWayToCanada === 'no') {
                permitType = types.TYPE_DAYUSE_MOTOR;
            }
            const item = {
                permit_id: permitId,
                permit_type: permitType,
                division_id: this.props.selectedDivision2.id,
                user_id: SecurityHelper.getAccount().account_id,
                start_date: gnoment(this.props.selectedStartDate2),
                status: issuanceStatuses.get(types.PERMIT_PRELIMINARY),
                equipments: [
                    {
                        type: types.EQUIP_TYPE_MOTORBOAT,
                        qty: 1,
                    },
                ],
            };
            items.push(item);
        }

        const gate_a = await getGateA(
            this.props.recaptcha,
            RECAPTCHA_ACTION_CREATE_ISSUANCE
        );
        let issuanceIds;
        this.props.dispatch({
            type: types.SET_ISSUANCE_LOADING,
            issuanceLoading: true,
        });
        try {
            issuanceIds = await pActions.addItems(items, gate_a);
        } catch (error) {
            const { shouldRetry, isFailed } =
                this.props.recaptcha.handleRecaptchaError(error);
            if (shouldRetry) {
                // Challenge required - pop the v2 checkbox modal for the retry.
                this.setState({ isChallengeModalOpen: true });
                return;
            }
            if (isFailed) {
                // Hard reCAPTCHA denial - do not auto-retry.
                this.setState({
                    isChallengeModalOpen: false,
                    isMessageModalOpen: true,
                    message: RECAPTCHA_FAILED_MESSAGE,
                    messageTitle: 'Error',
                });
                return;
            }

            let msg = `${error}`;
            if (error.response && error.response.data && error.response.data.error) {
                msg = `${error.response.data.error}`;
            }
            const errStr = formatErrorMessage(msg);
            this.setState({
                isChallengeModalOpen: false,
                isMessageModalOpen: true,
                message: errStr,
                messageTitle: 'Error',
            });
            return;
        } finally {
            this.props.dispatch({
                type: types.SET_ISSUANCE_LOADING,
                issuanceLoading: false,
            });
        }

        this.setState({ isChallengeModalOpen: false });
        const reservationIds = [];
        issuanceIds.forEach((id) => {
            reservationIds.push(`${id}${types.RES_ID_DELIMITER}${permitId}`);
        });

        const idsStr = reservationIds.join(',');
        const redirectURL = `/permits/${permitId}/registration/${idsStr}/select-cooperator`;
        this.props.router.navigate(redirectURL);
    }

    onNavigatorDateChanged(dates) {
        this.props.handleDateChange(dates.startDate);
    }

    getFilteredDivisions(divisionObjs, type, searchCriteria) {
        const ret = [];
        if (divisionObjs && type) {
            Object.keys(divisionObjs).forEach((id) => {
                const division = divisionObjs[id];
                if (
                    division.type === type ||
                    (type === 'DC' && division.name.indexOf('dc)') > 0)
                ) {
                    ret[ret.length] = division;
                }
            });
        }
        return this.applySearchCriteria(ret, searchCriteria);
    }

    handleDivisionDetailsClick = (divisionId) => {
        this.props.dispatch(pActions.openDivisionDetailsModal(divisionId));
    };

    applySearchCriteria(divisionObjs, searchCriteria) {
        let ret = divisionObjs;
        if (searchCriteria) {
            if (searchCriteria.searchText && searchCriteria.searchText !== '') {
                const searchText = searchCriteria.searchText.toLowerCase();
                ret = ret.filter((item) =>
                    `${item.name}  ${item.district}`.toLowerCase().includes(searchText)
                );
            }
            if (searchCriteria.areas.length > 0) {
                const retFiltered = [];
                forEach(ret, (item) => {
                    filter(
                        searchCriteria.areas,
                        (area) => item.district.includes(area) && retFiltered.push(item)
                    );
                    return retFiltered;
                });
                ret = retFiltered;
            }
            if (searchCriteria.canadianAccess === 'yes') {
                // this maps to the backend's values
                const objectConversionOfCanadianAccess = {
                    True: 'yes',
                    False: 'no',
                };
                ret = ret.filter((item) => {
                    if (item.description_map && item.description_map.AccessCanada) {
                        // currently stored as 'True' or 'False' on backend, needs to map to our frontend's 'yes' or 'no'
                        return (
                            objectConversionOfCanadianAccess[
                                item.description_map.AccessCanada
                            ] === searchCriteria.canadianAccess
                        );
                    }
                    return true;
                });
            }
        }
        return ret;
    }

    refreshAvailability() {
        if (this.state.permitId && this.state.permitDate) {
            const startDate = gnoment(this.state.permitDate);
            this.props.dispatch(
                aActions.fetchAvailability(
                    this.state.permitId,
                    startDate.clone().startOf('isoWeek').add(-2, 'day').toDate(),
                    startDate
                        .clone()
                        .startOf('isoWeek')
                        .add(-2, 'day')
                        .add(28, 'day')
                        .toDate(),
                    startDate.clone().utc().startOf('day').toISOString()
                )
            );
        }
    }

    renderAvailabilityNavigator = (
        { daysToSkip, weeksToSkip },
        handleClearDatesClick
    ) => {
        const { permitDate } = this.props;
        return (
            <AvailabilityNavigator
                startDate={gnoment(permitDate)}
                endDate={gnoment(permitDate).add(daysToSkip, 'day')}
                onDatesChange={this.onNavigatorDateChanged}
                handleClearDatesClick={handleClearDatesClick}
                daysToSkip={weeksToSkip ? null : daysToSkip}
                weeksToSkip={weeksToSkip}
            />
        );
    };

    renderToCanadaPanel() {
        const { daysToSkip } = this.props;
        let divisions = [];
        if (this.props.questionnaire.motorSpendNightOnWayToCanada === 'yes') {
            divisions = this.getFilteredDivisions(
                this.state.divisions,
                types.DIV_TYPE_OM,
                this.props.divisionSearchCriteria
            );
        }
        if (this.props.questionnaire.motorSpendNightOnWayToCanada === 'no') {
            const divisionsToFilter = this.getFilteredDivisions(
                this.state.divisions,
                types.DIV_TYPE_DM,
                this.props.divisionSearchCriteria
            );
            divisions = divisionsToFilter.filter(
                (i) => get(i, 'description_map.AccessCanada', 'False') === 'True'
            );
            // additionally filter by way to canada (DC type was removed)
        }
        return (
            <TabPanel label="Start in BWCAW traveling to Canada">
                <fieldset>
                    <legend>
                        <strong>Are you spending any nights in the BWCAW?</strong>
                    </legend>
                    <div className="rec-form-inline-item-wrap">
                        <div className="rec-form-inline-item">
                            <label
                                htmlFor="prompt-answer-yes1"
                                className="rec-label-radio"
                            >
                                <input
                                    className="rec-input-hide"
                                    type="radio"
                                    value="yes"
                                    id="prompt-answer-yes1"
                                    name="prompt-answer-yesno1"
                                    checked={
                                        this.props.questionnaire
                                            .motorSpendNightOnWayToCanada === 'yes'
                                    }
                                    onChange={this.handleSpendNightOnWayToCanadaChange}
                                    placeholder="Yes"
                                />
                                <span className="rec-input-radio" />
                                Yes
                            </label>
                        </div>
                        <div className="rec-form-inline-item">
                            <label
                                htmlFor="prompt-answer-no1"
                                className="rec-label-radio"
                            >
                                <input
                                    className="rec-input-hide"
                                    type="radio"
                                    id="prompt-answer-no1"
                                    name="prompt-answer-yesno1"
                                    value="no"
                                    checked={
                                        this.props.questionnaire
                                            .motorSpendNightOnWayToCanada === 'no'
                                    }
                                    onChange={this.handleSpendNightOnWayToCanadaChange}
                                    placeholder="No"
                                />
                                <span className="rec-input-radio" />
                                No
                            </label>
                        </div>
                    </div>
                </fieldset>

                <div aria-live="polite">
                    {this.props.questionnaire.motorSpendNightOnWayToCanada === 'yes' && (
                        <Alert type="info" hasAriaLive>
                            <p>
                                For a one-way trip or round-trip, you need (1) Overnight
                                Motor Permit
                                <strong>
                                    {' '}
                                    for the entry point and date you are entering the
                                    BWCAW{' '}
                                </strong>
                                whether the night in the BWCAW is at the beginning or the
                                end of the trip (or both).
                            </p>
                        </Alert>
                    )}

                    {this.props.questionnaire.motorSpendNightOnWayToCanada === 'no' && (
                        <Alert type="info" hasAriaLive>
                            <p>
                                You need a <strong>Day Use Motor permit</strong>. Select
                                the entry point and entry date you are entering the BWCAW.
                            </p>
                        </Alert>
                    )}
                </div>

                {this.props.questionnaire.motorSpendNightOnWayToCanada &&
                    this.props.questionnaire.motorSpendNightOnWayToCanada === 'no' && (
                        <div>
                            {this.renderAvailabilityNavigator(
                                { daysToSkip: 6, weeksToSkip: 4 },
                                this.onClearToCanadaDates
                            )}

                            <div className="per-availability-table-container">
                                <WeeklyMotorAvailability
                                    divisions={divisions}
                                    permitDate={this.props.permitDate}
                                    availabilities={this.props.availabilities}
                                    onDivisionDetailsClick={
                                        this.handleDivisionDetailsClick
                                    }
                                    onSelectToggle={this.onToCanadaSelectToggle}
                                    isSmallerGrid={this.props.isSmallerGrid}
                                    isFullView={this.props.isFullView}
                                    selectedDivision={this.props.selectedDivision}
                                    selectedStartDate={this.props.selectedStartDate}
                                    selectedEndDate={this.props.selectedEndDate}
                                >
                                    <Box className="pt-1" background="white">
                                        {this.renderAvailabilityNavigator(
                                            { daysToSkip: 6, weeksToSkip: 4 },
                                            this.onClearToCanadaDates
                                        )}
                                    </Box>
                                </WeeklyMotorAvailability>
                            </div>
                        </div>
                    )}

                {this.props.questionnaire.motorSpendNightOnWayToCanada &&
                    this.props.questionnaire.motorSpendNightOnWayToCanada === 'yes' && (
                        <div>
                            {this.renderAvailabilityNavigator(
                                { daysToSkip },
                                this.onClearToCanadaDates
                            )}
                            <AvailabilityMonths
                                numOfCols={this.props.numOfCols}
                                startDate={this.props.permitDate}
                            />

                            <OvernightAvailabilityGrid
                                divisions={divisions}
                                permitDate={this.props.permitDate}
                                availabilities={this.props.availabilities}
                                onDivisionDetailsClick={this.handleDivisionDetailsClick}
                                onSelectToggle={this.onToCanadaSelectToggle}
                                isSmallerGrid={this.props.isSmallerGrid}
                                isFullView={this.props.isFullView}
                                numOfCols={this.props.numOfCols}
                                selectedDivision={this.props.selectedDivision}
                                selectedStartDate={this.props.selectedStartDate}
                                selectedEndDate={this.props.selectedEndDate}
                            >
                                <Box className="pt-1" background="white">
                                    {this.renderAvailabilityNavigator(
                                        { daysToSkip },
                                        this.onClearToCanadaDates
                                    )}
                                    <AvailabilityMonths
                                        numOfCols={this.props.numOfCols}
                                        startDate={this.props.permitDate}
                                    />
                                </Box>
                            </OvernightAvailabilityGrid>
                        </div>
                    )}
            </TabPanel>
        );
    }

    renderFromCanadaPanel() {
        const { daysToSkip } = this.props;
        let divisions = [];
        if (this.props.questionnaire.motorSpendNightOnWayFromCanada === 'yes') {
            divisions = this.getFilteredDivisions(
                this.state.divisions,
                types.DIV_TYPE_OM,
                this.props.divisionSearchCriteria
            );
        }
        if (this.props.questionnaire.motorSpendNightOnWayFromCanada === 'no') {
            const divisionsToFilter = this.getFilteredDivisions(
                this.state.divisions,
                types.DIV_TYPE_DM,
                this.props.divisionSearchCriteria
            );
            divisions = divisionsToFilter.filter(
                (i) => get(i, 'description_map.AccessCanada', 'False') === 'True'
            );
            // additionally filter by comes from canada (DC type was removed)
        }
        return (
            <TabPanel label="Start in Canada traveling to BWCAW" className="from-canada">
                <fieldset>
                    <legend>
                        <strong>Are you spending any nights in the BWCAW?</strong>
                    </legend>
                    <div className="rec-form-inline-item-wrap">
                        <div className="rec-form-inline-item">
                            <label
                                htmlFor="prompt-answer-yes2"
                                className="rec-label-radio"
                            >
                                <input
                                    className="rec-input-hide"
                                    type="radio"
                                    value="yes"
                                    id="prompt-answer-yes2"
                                    name="prompt-answer-yesno2"
                                    checked={
                                        this.props.questionnaire
                                            .motorSpendNightOnWayFromCanada === 'yes'
                                    }
                                    onChange={this.handleSpendNightOnWayFromCanadaChange}
                                    placeholder="Yes"
                                />
                                <span className="rec-input-radio" />
                                Yes
                            </label>
                        </div>
                        <div className="rec-form-inline-item">
                            <label
                                htmlFor="prompt-answer-no2"
                                className="rec-label-radio"
                            >
                                <input
                                    className="rec-input-hide"
                                    type="radio"
                                    id="prompt-answer-no2"
                                    name="prompt-answer-yesno2"
                                    value="no"
                                    checked={
                                        this.props.questionnaire
                                            .motorSpendNightOnWayFromCanada === 'no'
                                    }
                                    onChange={this.handleSpendNightOnWayFromCanadaChange}
                                    placeholder="No"
                                />
                                <span className="rec-input-radio" />
                                No
                            </label>
                        </div>
                    </div>
                </fieldset>

                <div aria-live="polite">
                    {this.props.questionnaire.motorSpendNightOnWayFromCanada ===
                        'yes' && (
                        <Alert type="info" hasAriaLive>
                            <p>
                                For a one-way trip or round-trip, you need (1) Overnight
                                Motor Permit
                                <strong>
                                    {' '}
                                    for the entry point and date you are entering the
                                    BWCAW{' '}
                                </strong>
                                whether the night in the BWCAW is at the beginning or the
                                end of the trip (or both).
                            </p>
                        </Alert>
                    )}

                    {this.props.questionnaire.motorSpendNightOnWayFromCanada === 'no' && (
                        <Alert type="info" hasAriaLive>
                            <p>
                                You need a <strong>Day Use Motor permit</strong>. Select
                                the entry point and entry date you are entering the BWCAW.
                            </p>
                        </Alert>
                    )}
                </div>

                {this.props.questionnaire.motorSpendNightOnWayFromCanada &&
                    this.props.questionnaire.motorSpendNightOnWayFromCanada === 'no' && (
                        <div>
                            {this.renderAvailabilityNavigator(
                                { daysToSkip: 6, weeksToSkip: 4 },
                                this.onClearFromCanadaDates
                            )}

                            <div className="per-availability-table-container">
                                <WeeklyMotorAvailability
                                    divisions={divisions}
                                    permitDate={this.props.permitDate}
                                    availabilities={this.props.availabilities}
                                    onDivisionDetailsClick={
                                        this.handleDivisionDetailsClick
                                    }
                                    onSelectToggle={this.onFromCanadaSelectToggle}
                                    isSmallerGrid={this.props.isSmallerGrid}
                                    isFullView={this.props.isFullView}
                                    selectedDivision={this.props.selectedDivision2}
                                    selectedStartDate={this.props.selectedStartDate2}
                                    selectedEndDate={this.props.selectedEndDate2}
                                >
                                    <Box className="pt-1" background="white">
                                        {this.renderAvailabilityNavigator(
                                            { daysToSkip: 6, weeksToSkip: 4 },
                                            this.onClearFromCanadaDates
                                        )}
                                    </Box>
                                </WeeklyMotorAvailability>
                            </div>
                        </div>
                    )}

                {this.props.questionnaire.motorSpendNightOnWayFromCanada &&
                    this.props.questionnaire.motorSpendNightOnWayFromCanada === 'yes' && (
                        <div>
                            {this.renderAvailabilityNavigator(
                                { daysToSkip },
                                this.onClearFromCanadaDates
                            )}
                            <AvailabilityMonths
                                numOfCols={this.props.numOfCols}
                                startDate={this.props.permitDate}
                            />

                            <OvernightAvailabilityGrid
                                divisions={divisions}
                                permitDate={this.props.permitDate}
                                availabilities={this.props.availabilities}
                                onDivisionDetailsClick={this.handleDivisionDetailsClick}
                                onSelectToggle={this.onFromCanadaSelectToggle}
                                isSmallerGrid={this.props.isSmallerGrid}
                                isFullView={this.props.isFullView}
                                numOfCols={this.props.numOfCols}
                                selectedDivision={this.props.selectedDivision2}
                                selectedStartDate={this.props.selectedStartDate2}
                                selectedEndDate={this.props.selectedEndDate2}
                            >
                                <Box className="pt-1" background="white">
                                    {this.renderAvailabilityNavigator(
                                        { daysToSkip },
                                        this.onClearFromCanadaDates
                                    )}
                                    <AvailabilityMonths
                                        numOfCols={this.props.numOfCols}
                                        startDate={this.props.permitDate}
                                    />
                                </Box>
                            </OvernightAvailabilityGrid>
                        </div>
                    )}
            </TabPanel>
        );
    }

    render() {
        if (this.props.existingIssuance) {
            return (
                <Alert type="warning" hasAriaLive>
                    <p>
                        Modifying an existing reservation to{' '}
                        <strong>Motor trips to/from Canada</strong> is not allowed, you
                        must remove this reservation from your cart and recreate it.
                    </p>
                </Alert>
            );
        }

        let modalMessages = null;
        if (this.state.message) {
            modalMessages = [];
            const arr = this.state.message.split('\n');
            arr.forEach((msg, index) => {
                modalMessages.push(<li key={index}>{msg}</li>);
            });
        }

        return (
            <div className="per-availability-content">
                <p>
                    A quota permit is required for day use motor May 1 - September 30.
                    Motor weeks run Saturday - Friday. A reservation is only valid for one
                    day within the motor week. If you wish to enter the BWCAW on more than
                    one day in a motor week, you must make a reservation for each day.
                </p>
                <p>
                    Select permit type and entry date from the filters above to begin.
                    Click on filter box to narrow search.
                </p>
                <Tabs
                    stretchTabsToFit={false}
                    appearance="block"
                    className="mt-4"
                    activeIndex={this.props.activeTab}
                    selectedIndexChanged={() =>
                        // on change, reset all options. we only want to be able to allow end-users to create one permit type at a time.
                        this.props.dispatch(
                            pActions.setQuestionnaireAnswers({
                                motorSpendNightOnWayToCanada: null,
                                motorSpendNightOnWayFromCanada: null,
                            })
                        ) &&
                        this.onClearToCanadaDates() &&
                        this.onClearFromCanadaDates()
                    }
                >
                    {this.renderToCanadaPanel()}
                    {this.renderFromCanadaPanel()}
                </Tabs>
                {(this.props.questionnaire.motorSpendNightOnWayToCanada ||
                    this.props.questionnaire.motorSpendNightOnWayFromCanada) && (
                    <BookNowComponent
                        selectedDivision={this.props.selectedDivision}
                        selectedStartDate={this.props.selectedStartDate}
                        selectedEndDate={this.props.selectedEndDate}
                        selectedDivision2={this.props.selectedDivision2}
                        selectedStartDate2={this.props.selectedStartDate2}
                        selectedEndDate2={this.props.selectedEndDate2}
                        onBookClick={() => {
                            this.onBook();
                        }}
                        isMultiDestination
                        isEnabled={
                            !this.props.issuanceLoading &&
                            ((this.props.selectedDivision !== null &&
                                this.props.selectedStartDate !== null) ||
                                (this.props.selectedDivision2 !== null &&
                                    this.props.selectedStartDate2 !== null))
                        }
                    />
                )}

                <StyledModal
                    shouldShowCloseButton={false}
                    shouldActionsStickInMobile
                    size="md"
                    isOpen={this.state.isMessageModalOpen}
                    heading={this.state.messageTitle}
                    onRequestClose={this.onCloseMessageModal}
                >
                    {modalMessages}

                    <ModalActions>
                        <ButtonGroup isFullWidthOnMobile={false} isStretchedToFit>
                            <Button
                                onClick={this.onCloseMessageModal}
                                appearance="tertiary"
                            >
                                Close
                            </Button>
                        </ButtonGroup>
                    </ModalActions>
                </StyledModal>

                <SharedCaptchaModal
                    isOpen={this.state.isChallengeModalOpen}
                    onRequestClose={() => this.setState({ isChallengeModalOpen: false })}
                    onContinue={this.onBook}
                    heading="Confirm You're Not a Robot"
                    showCancelButton
                    isContinueDisabled={this.props.recaptcha.isV2Invalid}
                    isContinueLoading={this.props.issuanceLoading}
                >
                    Please complete the challenge below to continue with your reservation.
                    <RecaptchaCheckbox
                        {...this.props.recaptcha.recaptchaCheckboxProps}
                        isFallbackOnly
                        action={RECAPTCHA_ACTION_CREATE_ISSUANCE}
                    />
                </SharedCaptchaModal>
            </div>
        );
    }
}

function select(state) {
    return {
        account: state.auth.account,
        questionnaire: state.boundarywaters.questionnaire,
        permitId: state.boundarywaters.permit.result.id,
        permitDate: state.boundarywaters.permitDate,
        activeTab: state.boundarywaters.activeTab,
        selectedDivision: state.boundarywaters.selectedDivision,
        selectedStartDate: state.boundarywaters.selectedStartDate,
        selectedEndDate: state.boundarywaters.selectedEndDate,
        selectedDivision2: state.boundarywaters.selectedDivision2,
        selectedStartDate2: state.boundarywaters.selectedStartDate2,
        selectedEndDate2: state.boundarywaters.selectedEndDate2,
        availabilities: state.boundarywaters.permit.availabilities,
        permit: state.boundarywaters.permit.result,
        divisions: state.boundarywaters.permit.result.divisions,
        issuance: state.boundarywaters.permit.issuance,
        existingIssuance: state.boundarywaters.permit.existingIssuance,
        error: state.boundarywaters.permit.error,
        divisionSearchCriteria: state.boundarywaters.divisionSearchCriteria,
        issuanceLoading: state.boundarywaters.issuanceLoading,
    };
}

export default withCompatRouter(
    connect(select)(withRecaptchaFallback(AvailabilityCanadaMotorContainer))
);

//cspell:ignore DAYUSE, BWCAW, boundarywaters
